import MinifiedJobRow from "./MinifiedJobRow"

import PillButton from "@components/elements/V2/Buttons/PillButton"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { useJobAds } from "@stores/joblistings"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import { getAccentColor } from "@utils/V2/color"
import React from "react"

type Props = {
  blok: Storyblok.JobListSection
  mobileGridOrder?: number
}

const MinifiedJobListings = ({ blok }: Props) => {
  const { records, isLoading, error } = useJobAds()

  const maxJobs = blok.minifiedMaxJobs ?? 4
  const visibleRecords = records.slice(0, maxJobs)
  const accentColor = getAccentColor(blok.backgroundColor)

  if (isLoading) return null
  if (error) return null

  return (
    <div className="flex flex-col gap-32">
      <div>
        {visibleRecords.map((job) => (
          <MinifiedJobRow
            key={job.id}
            job={job}
            backgroundColor={blok.backgroundColor}
          />
        ))}
      </div>

      {blok.minifiedCtaLink && blok.minifiedCtaText && (
        <PillButton
          style="solid"
          size="medium"
          color={Color.Blue}
          text={blok.minifiedCtaText}
          linkUrl={storyblokLinkToYocoLink(blok.minifiedCtaLink)}
        />
      )}

      {blok.communityCtaLink?.url && (
        <>
          <div className="-mx-16 mb-10 mt-[37px] w-[calc(100%+32px)] border-b border-gray/10" />

          <div className="-mx-16 flex items-center justify-between">
            <Typography
              color={accentColor}
              size="body-md"
              weight="book"
              font="grotesk"
              text="Don't see your role? Let's still connect — join our talent community."
            />

            <PillButton
              text="Join the talent community"
              size="medium"
              style="bordered"
              color={Color.Blue}
              overrideTextColor={accentColor}
              linkUrl={storyblokLinkToYocoLink(blok.communityCtaLink)}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default MinifiedJobListings
